export const GoogleAnalyticsConfiguration = {
  GA_CODE: 'G-E5QNZVZRYY',
};
